import { useEffect } from 'react';
import { useTabPaneInfo } from './TabPaneContext';
import { useTabs } from './TabsContext';

/**
 * A page calls this to override its own tab's router-derived default title
 * (Pages.displayName, or "· #id" once an identity param is present) once real
 * record data has loaded — e.g. FundRecordPage sets "הגדרת קרן · קסם 20"
 * (plan §3.6). Pass `null` to leave the title untouched (typically while a
 * record hasn't loaded yet); pass the page's own default-title string in that
 * case if a permanent fallback is wanted — the reducer never re-derives a
 * title for a tab once useTabTitle has claimed it (see reducer.ts
 * `titleOverride`), so silence here just means "don't touch it yet", not
 * "revert to the router default". No-ops outside a tab pane.
 */
export function useTabTitle(title: string | null): void {
  const pane = useTabPaneInfo();
  const { setTitle } = useTabs();
  useEffect(() => {
    if (!pane || title == null) return;
    setTitle(pane.key, title);
  }, [pane, title, setTitle]);
}
